"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rewards API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionToJSON = exports.ActionFromJSONTyped = exports.ActionFromJSON = exports.instanceOfAction = void 0;
var ActionStrategyId_1 = require("./ActionStrategyId");
var ActionType_1 = require("./ActionType");
var EntityMetadata_1 = require("./EntityMetadata");
/**
 * Check if a given object implements the Action interface.
 */
function instanceOfAction(value) {
    var isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "score" in value;
    isInstance = isInstance && "strategyId" in value;
    isInstance = isInstance && "metadata" in value;
    return isInstance;
}
exports.instanceOfAction = instanceOfAction;
function ActionFromJSON(json) {
    return ActionFromJSONTyped(json, false);
}
exports.ActionFromJSON = ActionFromJSON;
function ActionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'type': (0, ActionType_1.ActionTypeFromJSON)(json['type']),
        'score': json['score'],
        'strategyId': (0, ActionStrategyId_1.ActionStrategyIdFromJSON)(json['strategyId']),
        'metadata': (0, EntityMetadata_1.EntityMetadataFromJSON)(json['metadata']),
    };
}
exports.ActionFromJSONTyped = ActionFromJSONTyped;
function ActionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'type': (0, ActionType_1.ActionTypeToJSON)(value.type),
        'score': value.score,
        'strategyId': (0, ActionStrategyId_1.ActionStrategyIdToJSON)(value.strategyId),
        'metadata': (0, EntityMetadata_1.EntityMetadataToJSON)(value.metadata),
    };
}
exports.ActionToJSON = ActionToJSON;
